import { Component, Inject, HostBinding, Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

export interface MessageBoxButton {
   class: string;
   label: string;
   action: (dialogRef: MatDialogRef<MessageBoxComponent>) => void;
}

export interface MessageBoxData {
   class: string;
   icon: string;
   title: string;
   message: string;
   ok: MessageBoxButton;
   close: MessageBoxButton;
}

@Component({
   selector: 'app-message-box',
   templateUrl: './message-box.html',
   styleUrls: ['./message-box.scss']
})
export class MessageBoxComponent {
   @HostBinding('style.margin')
   message: string;

   constructor(private dialogRef: MatDialogRef<MessageBoxComponent>,
               @Inject(MAT_DIALOG_DATA) public options: MessageBoxData | any) {
      this.message = this.options.message;
      if (!this.message && (typeof this.options === 'string')) {
         this.message = this.options;
      }
   }

   ok(): void {
      if (this.options.ok.action() === true) {
         this.dialogRef.close();
      }
   }

   close(): void {
      this.dialogRef.close();
      this.options.close.action();
   }
}

@Injectable()
export class MessageBox {
   constructor(private dialog: MatDialog) { }

   open(options: any): MatDialogRef<MessageBoxComponent> {
      return this.dialog.open(MessageBoxComponent, { disableClose: true, data: options });
   }
}
